import classNames from "classnames";
import * as styles from "./InstallStyles.module.scss";
import { Button, Title } from "@yoast/ui-library";
import { defineMessages, FormattedMessage } from "react-intl";
import React, { useContext } from "react";
import ButtonsContainer from "../general/ButtonsContainer";
import { ArrowLongLeftIcon, ArrowTopRightOnSquareIcon } from "@heroicons/react/20/solid";
import { InstallContext, Steps as allSteps } from "./InstallContext";

const messages = defineMessages( {
	title: {
		id: "finish.title",
		defaultMessage: "You've successfully completed the installation! 🎉",
	},
	noInstallationTitle: {
		id: "finish.alternativeTitle",
		defaultMessage: "Thank you for your purchase! 🎉",
	},
	installedMessage: {
		id: "finish.installedMessage",
		defaultMessage: "You're ready to start optimizing where you write!",
	},
	closeNotice: {
		id: "finish.closeNotice",
		defaultMessage: "It's safe to close this window, or you can go to MyYoast to view your invoice and subscription details.",
	},
	back: {
		id: "install.button.back",
		defaultMessage: "Back",
	},
	continueButton: {
		id: "install.button.continue",
		defaultMessage: "Go to MyYoast",
	},
	toBrandInsightsButton: {
		id: "finish.button.toBrandInsights",
		defaultMessage: "Go to Brand Insights",
	},
} );

/**
 * The last step of the installation flow, confirming the installation is complete.
 * @returns {Element} The JSX Element.
 */
export const FinishStep = () => {
	const { steps, goToPreviousStep } = useContext( InstallContext );

	// "CONNECT_YOUR_SITE"
	const includesInstallable   = steps.available.find( step => step.id === allSteps.CONNECT_YOUR_SITE.id );
	const includesDocsAddon     = steps.available.find( step => step.id === allSteps.INSTALL_DOCS_ADDON.id );

	const navigateToMyYoast = () => {
		window.open( "/", "_self" );
	};

	return (
		<div className={ classNames( styles.downloadingStep, styles.ySpacing ) }>
			<Title className={ styles.textCenter }>
				<FormattedMessage { ...( includesInstallable ? messages.title : messages.noInstallationTitle ) } />
			</Title>
			<hr />
			{ ( includesInstallable || includesDocsAddon ) && (
				<p className={ styles.textCenter }>
					<FormattedMessage { ...messages.installedMessage } />
				</p>
			) }

			<p className={ styles.textCenter }>
				<FormattedMessage tagName="em" { ...messages.closeNotice } />
			</p>

			<hr />
			<ButtonsContainer className={ styles.buttonContainer }>
				{ steps.canGoBack && (
					<Button variant="tertiary" onClick={ goToPreviousStep }>
						<ArrowLongLeftIcon className={ styles.buttonIcon } />
						<FormattedMessage { ...messages.back } />
					</Button>
				) }
				<Button variant="tertiary" onClick={ navigateToMyYoast }>
					<FormattedMessage { ...messages.continueButton } />
					<ArrowTopRightOnSquareIcon className={ styles.buttonIcon } />
				</Button>
			</ButtonsContainer>
		</div>
	);
};
